import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from '@/assets/img/ar.svg'
import _imports_1 from '@/assets/img/us.svg'


const _hoisted_1 = { class: "bg-white/80 backdrop-blur-md shadow-lg rounded-xl flex items-center justify-between px-4 lg:px-4 py-3 transition-all duration-300" }
const _hoisted_2 = { class: "flex items-center gap-x-3 flex-1" }
const _hoisted_3 = { class: "flex items-center gap-x-2 shrink-0" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_font_awesome_icon = _resolveComponent("font-awesome-icon")!
  const _component_Breadcrumbs = _resolveComponent("Breadcrumbs")!

  return (_openBlock(), _createElementBlock("header", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("button", {
        onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('toggle-sidebar'))),
        class: "lg:hidden text-gray-500 hover:text-gray-700 focus:outline-none focus:ring-2 focus:ring-inset focus:ring-green-500"
      }, [
        _cache[3] || (_cache[3] = _createElementVNode("span", { class: "sr-only" }, "Open sidebar", -1)),
        _createVNode(_component_font_awesome_icon, {
          icon: "bars",
          class: "h-6 w-6"
        })
      ]),
      _createVNode(_component_Breadcrumbs, {
        currentPage: _ctx.currentRouteName,
        class: "flex"
      }, null, 8, ["currentPage"])
    ]),
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("button", {
        onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.changeLanguage('es'))),
        class: "transition hover:scale-125 cursor-pointer"
      }, _cache[4] || (_cache[4] = [
        _createElementVNode("img", {
          src: _imports_0,
          class: "h-5 md:h-8 rounded-full"
        }, null, -1)
      ])),
      _createElementVNode("button", {
        onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.changeLanguage('en'))),
        class: "transition hover:scale-125 cursor-pointer"
      }, _cache[5] || (_cache[5] = [
        _createElementVNode("img", {
          src: _imports_1,
          class: "h-5 md:h-8 rounded-full"
        }, null, -1)
      ]))
    ])
  ]))
}